import { render, staticRenderFns } from "./myDiyList.vue?vue&type=template&id=8c41038e&scoped=true&"
import script from "./myDiyList.vue?vue&type=script&lang=js&"
export * from "./myDiyList.vue?vue&type=script&lang=js&"
import style0 from "./myDiyList.vue?vue&type=style&index=0&id=8c41038e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c41038e",
  null
  
)

export default component.exports